import React from 'react';
import { Menu, MenuItem } from '@mui/material';

import { getAnchorProps, MenuAnchor } from '@paragon/client-tools';
import { TruckDriver } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { setTruckDriverArchiveStatus } from '../../../actions/supervisorActions';
import { useAppDispatch, useAppSelector } from '../../hooks';

export function TruckDriverMenu(props: { truckDriver: TruckDriver; anchor: MenuAnchor; onClose: () => void }) {
  const { anchor, truckDriver } = props;
  const dispatch = useAppDispatch();
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);

  if (!isSupervisor) return null;

  return (
    <Menu open={anchor != null} {...getAnchorProps(anchor)} onClose={props.onClose}>
      <MenuItem
        onClick={async () => {
          props.onClose();
          dispatch(setTruckDriverArchiveStatus(truckDriver.guid, !truckDriver.archived));
        }}
      >
        {truckDriver.archived ? 'Unarchive' : 'Archive'}
      </MenuItem>
    </Menu>
  );
}
